// extracted by mini-css-extract-plugin
export default {"latest-articles":"LatestArticles_latest-articles__pVhto","title":"LatestArticles_title__J4QUL"};